/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface TecnicoDTO
 */
export interface TecnicoDTO {
    /**
     * 
     * @type {number}
     * @memberof TecnicoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TecnicoDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TecnicoDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof TecnicoDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the TecnicoDTO interface.
 */
export function instanceOfTecnicoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TecnicoDTOFromJSON(json: any): TecnicoDTO {
    return TecnicoDTOFromJSONTyped(json, false);
}

export function TecnicoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TecnicoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function TecnicoDTOToJSON(value?: TecnicoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

